import script from "./MyTreeSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyTreeSelect.vue?vue&type=script&setup=true&lang=ts"

import "./MyTreeSelect.vue?vue&type=style&index=0&id=4c0f0ed5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0f0ed5"]])

export default __exports__